// extracted by mini-css-extract-plugin
module.exports = {"title":"PDBStructure_title__31Ji6","subtitle":"PDBStructure_subtitle__mVcoX","viewportstyle":"PDBStructure_viewportstyle__2dXge"};